module.exports = "../../static/img/plus-circle.02cf3bb.svg";